<template>
    <div>
        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 cancel-title="Cancelar"
                 :ok-disabled=form.errors.any()
                 v-model="showModal"
                 @ok="handleOk">

            <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                <b-row no-gutters>
                    <b-col>
                        <b-form-radio-group label-size="lg" v-model="form.tipo_conexao" class="clearfix">
                             <b-form-radio value="1" class="float-left"><i class="fa fa-3x fa-upload"></i> FTP</b-form-radio>
                             <b-form-radio value="2" class="float-left"><i class="fa fa-3x fa-envelope-o"></i> EMAIL</b-form-radio>
                             <b-form-radio value="3" class="float-left"><i class="fa fa-3x fa-code-fork"></i> API</b-form-radio>
                        </b-form-radio-group>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('tipo_conexao')" v-if="form.errors.has('tipo_conexao')"></b-form-feedback>
                    </b-col>
                </b-row>

            </form>
            <div slot="modal-footer" class="w-100">
                <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                <div class="float-right">
                     <b-btn @click="showModal=false" variant="secondary">
                       Fechar
                     </b-btn>
                     <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                       Continuar
                     </b-btn>
                </div>
            </div>
        </b-modal>
        <PessoaConexaoFtpForm ref="pessoaconexaoftpform"></PessoaConexaoFtpForm>
        <PessoaConexaoEmailForm ref="pessoaconexaoemailform"></PessoaConexaoEmailForm>
        <PessoaConexaoApiForm ref="pessoaconexaoapiform"></PessoaConexaoApiForm>
    </div>
</template>
<script>

import PessoaConexaoFtpForm from './PessoaConexaoFtpForm'
import PessoaConexaoEmailForm from './PessoaConexaoEmailForm'
import PessoaConexaoApiForm from './PessoaConexaoApiForm'

export default {
components: {
    PessoaConexaoFtpForm,
    PessoaConexaoEmailForm,
    PessoaConexaoApiForm

},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({tipo_conexao: '',}),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
},
mounted() {

},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.form.tipo_conexao==1)
        {
           this.onCreateConexaoFtp();
        }
        else if (this.form.tipo_conexao==2)
        {
            this.onCreateConexaoEmail();
        }
        else
        {
            this.onCreateConexaoApi();
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar Conexão";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onCreateConexaoFtp ()
    {
        this.$refs.pessoaconexaoftpform.onCreate();
    },
    onCreateConexaoEmail ()
    {
        this.$refs.pessoaconexaoemailform.onCreate();
    },
    onCreateConexaoApi ()
    {
        this.$refs.pessoaconexaoapiform.onCreate();
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
